import template from './sw-cms-el-preview-product-listing.html.twig';
import './sw-cms-el-preview-product-listing.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
